import { useMemo } from "react";
import { useFormikContext } from "formik";
import { Paper, Stack, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { HugeiconsIcon } from "@hugeicons/react";
import { PaintBoardIcon } from "@hugeicons/core-free-icons";
import { useAppSelector } from "@/hooks";
import { getThumbnailImage } from "@/utils/media";
import MediaManager from "@/components/media-manager/MediaManager";
import ColorPicker from "@/components/ColorPicker";

const VisualIdentitySection = () => {
  const { values, setFieldValue, handleChange } = useFormikContext<any>();
  const organizationId = useAppSelector((store) => store.ui.activeOrganization);
  const theme = useTheme();

  // Dynamically find the logo key in settings, default to "logo"
  const logoKey = useMemo(() => {
    return (
      Object.keys(values.settings ?? {}).find((key) => key.toLowerCase() === "logo") ||
      "logo"
    );
  }, [values.settings]);

  const logoSetting = values.settings?.[logoKey];
  const logoUrl = useMemo(() => {
    return logoSetting?.value
      ? getThumbnailImage({ file: String(logoSetting.value), organizationId })
      : "";
  }, [logoSetting?.value, organizationId]);

  const handleLogoChange = (selection: string[]) => {
    const setting = values.settings?.[logoKey] ?? {};
    setFieldValue(`settings.${logoKey}`, { ...setting, value: selection[0] });
  };

  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Stack spacing={3}>
        {/* Section Title with Icon */}
        <Stack direction="row" spacing={2} alignItems="center">
          <HugeiconsIcon icon={PaintBoardIcon} size={32} color={theme.palette.primary.main} />
          <Typography variant="h3">Identidad Visual</Typography>
        </Stack>

        <Grid container spacing={3}>
          {/* Logo del Restaurante */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <Stack spacing={1}>
              <Typography variant="h4">Logotipo</Typography>
              <Paper sx={{
                padding: 2,
                overflow: 'hidden',
                borderRadius: '12px',
              }}>
                <MediaManager
                  value={logoUrl}
                  onChange={handleLogoChange}
                />
              </Paper>
            </Stack>

          </Grid>

          {/* Color de Marca */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <Stack spacing={1}>
              <Typography variant="h4">Color de Marca</Typography>
              <ColorPicker
                name="organization.primaryColor"
                value={values.organization.primaryColor}
                onChange={handleChange}
                condensed
              />
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </Paper>
  );
};

export default VisualIdentitySection;
